import { setUser, setUserIsLoading } from '../store/user.js';
import { api } from './api.js';
import { TAG_LIST_USERS } from './tags.js';

export const authEndpoints = api.enhanceEndpoints({ addTagTypes: ['user'] }).injectEndpoints({
    endpoints: (builder) => ({
        updateProfile: builder.mutation({
            query: (data) => ({
                url: '/user',
                method: 'POST',
                body: data
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                dispatch(setUser(data.response.user));
                dispatch(setUserIsLoading(false));
            }
        }),
        updatePicture: builder.mutation({
            query: ({ picture }) => {
                const body = new FormData();
                body.append('Content-Type', picture.type);
                body.append('picture', picture);

                return {
                    url: `/user/picture`,
                    method: 'POST',
                    body
                };
            },
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                dispatch(setUser(data.response.user));
                dispatch(setUserIsLoading(false));
            }
        }),
        getUser: builder.query({
            query: () => ({
                url: '/user',
                method: 'GET'
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                dispatch(setUser(data.response.user));
                dispatch(setUserIsLoading(false));
            }
        }),
        logout: builder.query({
            query: (args) => ({
                url: '/logout',
                method: 'POST',
                body: args
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                await queryFulfilled;
                sessionStorage.clear();
                localStorage.removeItem('accessToken');
                localStorage.removeItem('mfaIdentifier');
                dispatch(api.util.resetApiState());
                dispatch(setUser(false));
            }
        }),
        getPendingUsers: builder.query({
            query: () => ({
                url: '/users/pending',
                method: 'GET'
            }),
            providesTags: [TAG_LIST_USERS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getApprovedUsers: builder.query({
            query: () => ({
                url: '/users/approved',
                method: 'GET'
            }),
            providesTags: [TAG_LIST_USERS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        deleteUser: builder.mutation({
            query: (id) => ({
                url: `/users/delete-user/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [TAG_LIST_USERS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        approveChangeUserRole: builder.mutation({
            query: ({ id, data }) => ({
                url: `/users/change-role/${id}`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_USERS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        registerPushToken: builder.mutation({
            query: ({ type, data }) => ({
                url: '/push-token',
                method: 'POST',
                body: { type, data },
                toast: false
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (err) {
                    console.error('Failed to register push token:', err);
                }
            }
        })
    })
});

export const {
    useUpdateProfileMutation,
    useGetUserQuery,
    useLazyGetUserQuery,
    useLogoutQuery,
    useUpdatePictureMutation,
    useGetPendingUsersQuery,
    useGetApprovedUsersQuery,
    useDeleteUserMutation,
    useApproveChangeUserRoleMutation,
    useRegisterPushTokenMutation
} = authEndpoints;
